import { useEffect, useState } from 'react';
import { AgxRadio, AgxDatePicker, AgxLabel } from '@urbanx/agx-ui-components';
import dayjs from 'dayjs';
import { AgreementLength } from './types';

interface LengthOfAgreementProps {
  onLengthOfAgreementChange: (value: string | AgreementLength) => void;
  specificDateChange: (value: string | undefined) => void;
  defaultLengthOfAgreement?: string | AgreementLength;
  defaultSpecificDate?: string;
  days?: number[];
  validate?: boolean;
  restrictDuration?: boolean;
  startDate?: string;
}

export const LengthOfAgreement = ({
  onLengthOfAgreementChange,
  specificDateChange,
  defaultLengthOfAgreement = undefined,
  defaultSpecificDate = undefined,
  days,
  validate,
  restrictDuration,
  startDate,
}: LengthOfAgreementProps) => {
  const [selectedAgreementLength, setSelectedAgreementLength] = useState(
    defaultLengthOfAgreement ?? AgreementLength.NinetyDays
  );

  useEffect(() => {
    onLengthOfAgreementChange(selectedAgreementLength);
  }, [selectedAgreementLength]);

  const [specificDate, setSpecificDate] = useState(
    defaultSpecificDate && dayjs(defaultSpecificDate).format('YYYY-MM-DD')
  );

  useEffect(() => {
    specificDateChange(specificDate);
  }, [specificDate]);

  const lengthOfAgreement = days?.map(d => (
    <AgxRadio
      key={'agreementLength' + d}
      id={'agreementLength' + d}
      label={d + ' days'}
      onCheckChanged={() => setSelectedAgreementLength(d.toString())}
      checked={selectedAgreementLength === d.toString()}
    />
  ));

  return (
    <div className="agxRadio">
      <AgxLabel medium>Length of Appointment</AgxLabel>
      <div className="agxRadio-group">
        {lengthOfAgreement}
        <AgxRadio
          key="agreementLength-specificDate"
          id="agreementLength-specificDate"
          label="Specific end date"
          onCheckChanged={() =>
            setSelectedAgreementLength(AgreementLength.SpecificDate)
          }
          checked={selectedAgreementLength === AgreementLength.SpecificDate}
          subContent={
            selectedAgreementLength === AgreementLength.SpecificDate
              ? [
                  <AgxDatePicker
                    key="LengthOfAgreementSpecificDate"
                    id="LengthOfAgreementSpecificDate"
                    onValueChanged={({ value }) => setSpecificDate(value)}
                    defaultValue={specificDate}
                    required
                    date
                    noHeader
                    stretch
                    maxDaysFromDate={
                      restrictDuration
                        ? {
                            days: days ? Math.max(...days.map(Number)) : 0,
                            date: startDate,
                          }
                        : undefined
                    }
                    error={
                      validate &&
                      (!specificDate || specificDate === 'Invalid date')
                        ? 'Enter specific end date'
                        : undefined
                    }
                  />,
                ]
              : undefined
          }
        />
      </div>
    </div>
  );
};
